import { CSSObject } from '@chakra-ui/react';

export const Accordion: CSSObject = {
  borderRadius: 'base',
  overflow: 'hidden',
  bg: 'gray.200',
  position: 'relative',
  zIndex: '999',
  '.chakra-accordion__item': {
    _first: {
      borderTop: '0',
    },
    _last: {
      borderBottom: '0',
    },
  },

  '.chakra-accordion__panel': {
    color: 'gray.600',
    bg: 'gray.50',
  },
};

export const AccordionHeader: CSSObject = {
  bgGradient: 'linear(to-b, beta.400, beta.600)',
  color: 'white',
  transitionDuration: 'normal',
  transitionProperty: 'common',
  _hover: {
    bg: 'zeta.300',
    color: 'alpha.600',
  },
  _focus: {
    bg: 'zeta.300',
    color: 'alpha.600',
  },
};

export const OverviewPromotionsPanel: CSSObject = {
  bgColor: 'zeta.200',
  '.chakra-checkbox__label': {
    color: 'gray.600',
  },
};

export const AccordionHeaderLogOut: CSSObject = {
  borderRadius: 'base',
  color: 'alpha.700',
  border: 'none',
  position: 'relative',
  zIndex: '999',
  _hover: {
    bg: 'zeta.300',
    color: 'alpha.600',
  },
  _focus: {
    bg: 'zeta.300',
    color: 'alpha.600',
  },
};

export const IconPerson: CSSObject = {
  boxSize: ['5', null, '6'],
  mr: '1.5',
  color: 'white',
  '> path': {
    fill: 'white',
  },
};

export const TextAccordion: CSSObject = {
  fontSize: ['xs', null, 'sm'],
  fontWeight: 'semibold',
  mr: 'auto',
  color: 'white',
};

export const FlexContactToChange: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  bg: 'alpha.400',
  borderRadius: 'lg',
  boxShadow: '0px 4px 5px 0px rgba(0, 0, 0, 0.10)',
  color: 'white',
  fontSize: 'xs',
  gap: '1',
  p: '2',
};

export const OverviewAccordionItem: CSSObject = {
  borderTop: 'none',
};
